// ============================================================================
// CHINESE (SIMPLIFIED) BIBLE PASSAGES - Union Version
// ============================================================================
// 中文圣经经文，附有斯特朗编号参考

export const biblePassagesZh = {
  "Chuangshiji_1": {
    book: "创世记",
    chapter: 1,
    title: "创造世界",
    verses: [
      { number: 1, text: "起初，神创造天地。", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "地是空虚混沌，渊面黑暗；神的灵运行在水面上。", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "神说：要有光，就有了光。", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "神看光是好的，就把光暗分开了。", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "神称光为昼，称暗为夜。有晚上，有早晨，这是头一日。", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "神说：诸水之间要有空气，将水分为上下。", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "神就造出空气，将空气以下的水、空气以上的水分开了。事就这样成了。", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "神称空气为天。有晚上，有早晨，是第二日。", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "神就照着自己的形像造人，乃是照着他的形像造男造女。", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "神看着一切所造的都甚好。有晚上，有早晨，是第六日。", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Shipiān_23": {
    book: "诗篇",
    chapter: 23,
    title: "耶和华是我的牧者",
    verses: [
      { number: 1, text: "耶和华是我的牧者，我必不至缺乏。", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "他使我躺卧在青草地上，领我在可安歇的水边。", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "他使我的灵魂苏醒，为自己的名引导我走义路。", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "我虽然行过死荫的幽谷，也不怕遭害，因为你与我同在；你的杖，你的竿，都安慰我。", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "在我敌人面前，你为我摆设筵席；你用油膏了我的头，使我的福杯满溢。", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "我一生一世必有恩惠慈爱随着我；我且要住在耶和华的殿中，直到永远。", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yuehanfuyin_3": {
    book: "约翰福音",
    chapter: 3,
    title: "耶稣和尼哥底母",
    verses: [
      { number: 16, text: "神爱世人，甚至将他的独生子赐给他们，叫一切信他的，不至灭亡，反得永生。", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "因为神差他的儿子降世，不是要定世人的罪，乃是要叫世人因他得救。", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "信他的人，不被定罪；不信的人，罪已经定了，因为他不信神独生子的名。", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Feilipianshu_4": {
    book: "腓立比书",
    chapter: 4,
    title: "神的平安",
    verses: [
      { number: 4, text: "你们要靠主常常喜乐。我再说，你们要喜乐。", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "应当一无挂虑，只要凡事藉着祷告、祈求，和感谢，将你们所要的告诉神。", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "神所赐、出人意外的平安必在基督耶稣里保守你们的心怀意念。", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "我靠着那加给我力量的，凡事都能做。", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesZh;
